import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-sm text-red-500"
}
const _hoisted_2 = { class: "flex flex-col gap-1 text-sm" }
const _hoisted_3 = { class: "flex flex-col gap-1 text-sm" }
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_5 = { class: "flex flex-col gap-1 text-sm" }
const _hoisted_6 = { class: "flex flex-col gap-1 text-sm" }
const _hoisted_7 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_8 = { class: "flex flex-col gap-1 text-sm" }
const _hoisted_9 = { class: "flex flex-col gap-1 text-sm" }
const _hoisted_10 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_11 = { class: "flex flex-col gap-1 text-sm" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "flex flex-col gap-1 text-sm" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "flex flex-col gap-1 text-sm" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "flex flex-col gap-1 text-sm" }
const _hoisted_18 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_19 = { class: "flex flex-col gap-1 text-sm" }
const _hoisted_20 = { class: "flex flex-col gap-1 text-sm" }
const _hoisted_21 = { class: "flex flex-col gap-1 text-sm" }
const _hoisted_22 = { id: "admin-slides-releases" }
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "flex flex-col gap-1 text-sm" }
const _hoisted_25 = { class: "flex flex-col gap-1 text-sm md:col-span-2" }
const _hoisted_26 = { class: "flex flex-col gap-2 text-sm" }
const _hoisted_27 = { class: "flex flex-col gap-2" }
const _hoisted_28 = {
  key: 0,
  class: "flex items-start gap-3"
}
const _hoisted_29 = ["src"]
const _hoisted_30 = {
  key: 1,
  class: "flex flex-col gap-1"
}
const _hoisted_31 = { class: "flex gap-3" }
const _hoisted_32 = ["disabled"]

import type { StrongRef, TalkGroupRecord, TalkRecord } from '#shared/cms/records'
import { community } from '#shared/lex'
import { ref } from 'vue'
import { COMMUNITY_IMAGE_MAX_BYTES, pdsBlobUrl } from '#shared/cms/blob'

type TalkValue = Omit<TalkRecord, '$type'>

interface TalkGroupEntry {
  rkey: string
  uri: string
  cid: string
  value: TalkGroupRecord
}

interface GitHubRelease {
  tag: string
  name: string
  publishedAt: string | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TalkForm',
  props: {
    initial: {},
    submitLabel: {}
  },
  emits: ["submit"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { data: groups } = useAdminFetch<TalkGroupEntry[]>('/api/admin/talk-groups', { default: () => [] })
const { data: releases } = useAdminFetch<GitHubRelease[]>('/api/admin/github-releases', { default: () => [] })

const { public: publicConfig } = useRuntimeConfig()
const pdsService = publicConfig.atproto?.service || null
const pdsDid = publicConfig.atproto?.did || null

const TYPES = ['conference', 'meetup', 'podcast', 'workshop', 'stream', 'talk'] as const
const ROLES = ['speaker', 'keynote', 'panelist', 'host'] as const

const form = reactive({
  title: props.initial?.title ?? '',
  description: props.initial?.description ?? '',
  date: toDateInput(props.initial?.date) ?? '',
  endDate: toDateInput(props.initial?.endDate) ?? '',
  source: props.initial?.source ?? '',
  location: props.initial?.location ?? '',
  type: (props.initial?.type as typeof TYPES[number]) ?? 'conference',
  role: props.initial?.role ?? '',
  tags: (props.initial?.tags ?? []).join(', '),
  link: props.initial?.link ?? '',
  video: props.initial?.video ?? '',
  slides: props.initial?.slides ?? '',
  demo: props.initial?.demo ?? '',
  repo: props.initial?.repo ?? '',
  groupUri: props.initial?.group?.uri ?? '',
  image: props.initial?.image?.image,
  imageAlt: props.initial?.image?.alt ?? '',
  aspectRatio: props.initial?.image?.aspectRatio,
})

/**
 * Local object URL for a just-uploaded image, so the user sees a preview
 * before the record is saved. Cleared when the underlying image changes or
 * the component unmounts.
 */
const localPreviewUrl = ref<string | null>(null)
onBeforeUnmount(() => {
  if (localPreviewUrl.value) URL.revokeObjectURL(localPreviewUrl.value)
})

const submitting = ref(false)
const error = ref<string | null>(null)

function toDateInput (iso?: string): string | undefined {
  if (!iso) return undefined
  return iso.slice(0, 10)
}

const imageUrl = computed(() => {
  if (localPreviewUrl.value) return localPreviewUrl.value
  return pdsBlobUrl(pdsService, pdsDid, form.image)
})

async function onImageChange (e: Event) {
  const file = (e.target as HTMLInputElement).files?.[0]
  if (!file) return

  if (file.size > COMMUNITY_IMAGE_MAX_BYTES) {
    error.value = `That image is ${(file.size / 1_000_000).toFixed(1)} MB; the record format allows 2 MB.`
    return
  }

  if (localPreviewUrl.value) URL.revokeObjectURL(localPreviewUrl.value)
  localPreviewUrl.value = URL.createObjectURL(file)

  const buf = new Uint8Array(await file.arrayBuffer())
  try {
    const uploaded = await $fetch<{
      blob: NonNullable<NonNullable<TalkValue['image']>['image']>
      aspectRatio?: { width: number, height: number }
    }>('/api/admin/blobs', {
      method: 'POST',
      body: buf,
      headers: { 'content-type': file.type || 'application/octet-stream' },
    })
    form.image = uploaded.blob
    form.aspectRatio = uploaded.aspectRatio
    if (!form.imageAlt && form.source) form.imageAlt = `Logo for ${form.source}`
  }
  catch (err) {
    error.value = err instanceof Error ? err.message : String(err)
    if (localPreviewUrl.value) {
      URL.revokeObjectURL(localPreviewUrl.value)
      localPreviewUrl.value = null
    }
  }
}

function clearImage () {
  form.image = undefined
  form.aspectRatio = undefined
  form.imageAlt = ''
  if (localPreviewUrl.value) {
    URL.revokeObjectURL(localPreviewUrl.value)
    localPreviewUrl.value = null
  }
}

async function onSubmit () {
  error.value = null
  submitting.value = true
  try {
    if (form.image && !form.imageAlt) {
      error.value = 'Please describe the image for screen reader users.'
      submitting.value = false
      return
    }

    const group = (groups.value ?? []).find(g => g.uri === form.groupUri)
    const groupRef: StrongRef | undefined = group
      ? { uri: group.uri, cid: group.cid }
      : undefined

    const value: TalkValue = {
      ...(form.title ? { title: form.title } : {}),
      ...(form.description ? { description: form.description } : {}),
      date: new Date(form.date).toISOString(),
      ...(form.endDate ? { endDate: new Date(form.endDate).toISOString() } : {}),
      source: form.source,
      ...(form.location ? { location: form.location } : {}),
      type: form.type,
      ...(form.role ? { role: form.role } : {}),
      ...(form.tags.trim() ? { tags: form.tags.split(',').map(t => t.trim()).filter(Boolean) } : {}),
      ...(form.link ? { link: form.link } : {}),
      ...(form.video ? { video: form.video } : {}),
      ...(form.slides ? { slides: form.slides } : {}),
      ...(form.demo ? { demo: form.demo } : {}),
      ...(form.repo ? { repo: form.repo } : {}),
      ...(groupRef ? { group: groupRef } : {}),
      ...(form.image
        ? {
            image: {
              $type: 'community.lexicon.app.defs#image' as const,
              purpose: community.lexicon.app.defs.purposeLogo.value,
              image: form.image,
              alt: form.imageAlt,
              ...(form.aspectRatio ? { aspectRatio: form.aspectRatio } : {}),
            },
          }
        : {}),
      ...(props.initial?.createdAt ? { createdAt: props.initial.createdAt } : { createdAt: new Date().toISOString() }),
    }

    emit('submit', value)
  }
  catch (err) {
    error.value = err instanceof Error ? err.message : String(err)
  }
  finally {
    submitting.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_NuxtLink = _resolveComponent("NuxtLink")!

  return (_openBlock(), _createElementBlock("form", {
    class: "flex flex-col gap-4",
    onSubmit: _withModifiers(onSubmit, ["prevent"])
  }, [
    (error.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("label", _hoisted_2, [
      _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-muted" }, "Title", -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).title) = $event)),
        type: "text",
        class: "bg-accent px-3 py-2"
      }, null, 512), [
        [_vModelText, _unref(form).title]
      ])
    ]),
    _createElementVNode("label", _hoisted_3, [
      _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-muted" }, "Description", -1)),
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).description) = $event)),
        rows: "3",
        class: "bg-accent px-3 py-2"
      }, null, 512), [
        [_vModelText, _unref(form).description]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", _hoisted_5, [
        _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-muted" }, [
          _createTextVNode("Date "),
          _createElementVNode("span", { class: "text-red-500" }, "*")
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).date) = $event)),
          required: "",
          type: "date",
          class: "bg-accent px-3 py-2"
        }, null, 512), [
          [_vModelText, _unref(form).date]
        ])
      ]),
      _createElementVNode("label", _hoisted_6, [
        _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-muted" }, "End date (multi-day)", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).endDate) = $event)),
          type: "date",
          class: "bg-accent px-3 py-2"
        }, null, 512), [
          [_vModelText, _unref(form).endDate]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("label", _hoisted_8, [
        _cache[20] || (_cache[20] = _createElementVNode("span", { class: "text-muted" }, [
          _createTextVNode("Source / event "),
          _createElementVNode("span", { class: "text-red-500" }, "*")
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).source) = $event)),
          required: "",
          type: "text",
          class: "bg-accent px-3 py-2"
        }, null, 512), [
          [_vModelText, _unref(form).source]
        ])
      ]),
      _createElementVNode("label", _hoisted_9, [
        _cache[21] || (_cache[21] = _createElementVNode("span", { class: "text-muted" }, "Location", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).location) = $event)),
          type: "text",
          class: "bg-accent px-3 py-2"
        }, null, 512), [
          [_vModelText, _unref(form).location]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("label", _hoisted_11, [
        _cache[22] || (_cache[22] = _createElementVNode("span", { class: "text-muted" }, [
          _createTextVNode("Type "),
          _createElementVNode("span", { class: "text-red-500" }, "*")
        ], -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).type) = $event)),
          required: "",
          class: "bg-accent px-3 py-2"
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(TYPES, (t) => {
            return _createElementVNode("option", {
              key: t,
              value: t
            }, _toDisplayString(t), 9, _hoisted_12)
          }), 64))
        ], 512), [
          [_vModelSelect, _unref(form).type]
        ])
      ]),
      _createElementVNode("label", _hoisted_13, [
        _cache[24] || (_cache[24] = _createElementVNode("span", { class: "text-muted" }, "Role", -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).role) = $event)),
          class: "bg-accent px-3 py-2"
        }, [
          _cache[23] || (_cache[23] = _createElementVNode("option", { value: "" }, " (default) ", -1)),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ROLES, (r) => {
            return _createElementVNode("option", {
              key: r,
              value: r
            }, _toDisplayString(r), 9, _hoisted_14)
          }), 64))
        ], 512), [
          [_vModelSelect, _unref(form).role]
        ])
      ]),
      _createElementVNode("label", _hoisted_15, [
        _cache[26] || (_cache[26] = _createElementVNode("span", { class: "text-muted" }, "Group", -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).groupUri) = $event)),
          class: "bg-accent px-3 py-2"
        }, [
          _cache[25] || (_cache[25] = _createElementVNode("option", { value: "" }, " - none - ", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groups) ?? [], (g) => {
            return (_openBlock(), _createElementBlock("option", {
              key: g.uri,
              value: g.uri
            }, _toDisplayString(g.value.title), 9, _hoisted_16))
          }), 128))
        ], 512), [
          [_vModelSelect, _unref(form).groupUri]
        ])
      ])
    ]),
    _createElementVNode("label", _hoisted_17, [
      _cache[27] || (_cache[27] = _createElementVNode("span", { class: "text-muted" }, "Tags (comma-separated)", -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(form).tags) = $event)),
        type: "text",
        class: "bg-accent px-3 py-2"
      }, null, 512), [
        [_vModelText, _unref(form).tags]
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("label", _hoisted_19, [
        _cache[28] || (_cache[28] = _createElementVNode("span", { class: "text-muted" }, "Event link", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(form).link) = $event)),
          type: "url",
          class: "bg-accent px-3 py-2"
        }, null, 512), [
          [_vModelText, _unref(form).link]
        ])
      ]),
      _createElementVNode("label", _hoisted_20, [
        _cache[29] || (_cache[29] = _createElementVNode("span", { class: "text-muted" }, "Video link", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(form).video) = $event)),
          type: "url",
          class: "bg-accent px-3 py-2"
        }, null, 512), [
          [_vModelText, _unref(form).video]
        ])
      ]),
      _createElementVNode("label", _hoisted_21, [
        _cache[30] || (_cache[30] = _createElementVNode("span", { class: "text-muted" }, "Slides (GitHub release tag)", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(form).slides) = $event)),
          type: "text",
          list: "admin-slides-releases",
          class: "bg-accent px-3 py-2"
        }, null, 512), [
          [_vModelText, _unref(form).slides]
        ]),
        _createElementVNode("datalist", _hoisted_22, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(releases) ?? [], (r) => {
            return (_openBlock(), _createElementBlock("option", {
              key: r.tag,
              value: r.tag
            }, _toDisplayString(r.name), 9, _hoisted_23))
          }), 128))
        ])
      ]),
      _createElementVNode("label", _hoisted_24, [
        _cache[31] || (_cache[31] = _createElementVNode("span", { class: "text-muted" }, "Demo link", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(form).demo) = $event)),
          type: "url",
          class: "bg-accent px-3 py-2"
        }, null, 512), [
          [_vModelText, _unref(form).demo]
        ])
      ]),
      _createElementVNode("label", _hoisted_25, [
        _cache[32] || (_cache[32] = _createElementVNode("span", { class: "text-muted" }, "Repo link", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(form).repo) = $event)),
          type: "url",
          class: "bg-accent px-3 py-2"
        }, null, 512), [
          [_vModelText, _unref(form).repo]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("label", _hoisted_27, [
        _cache[33] || (_cache[33] = _createElementVNode("span", { class: "text-muted" }, "Image", -1)),
        _createElementVNode("input", {
          type: "file",
          accept: "image/*",
          class: "text-sm",
          onChange: onImageChange
        }, null, 32)
      ]),
      (_unref(imageUrl))
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("img", {
              src: _unref(imageUrl),
              alt: "Talk image preview",
              class: "max-h-40 bg-accent object-contain"
            }, null, 8, _hoisted_29),
            _createElementVNode("button", {
              type: "button",
              class: "text-xs text-muted hover:text-red-500 transition-colors",
              onClick: clearImage
            }, " Remove ")
          ]))
        : _createCommentVNode("", true),
      (_unref(form).image)
        ? (_openBlock(), _createElementBlock("label", _hoisted_30, [
            _cache[34] || (_cache[34] = _createElementVNode("span", { class: "text-muted" }, [
              _createTextVNode("Alt text "),
              _createElementVNode("span", { class: "text-red-500" }, "*")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(form).imageAlt) = $event)),
              type: "text",
              required: "",
              class: "bg-accent px-3 py-2"
            }, null, 512), [
              [_vModelText, _unref(form).imageAlt]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("button", {
        type: "submit",
        disabled: submitting.value,
        class: "bg-primary text-background px-4 py-2 hover:bg-primary/90 transition-colors disabled:opacity-60"
      }, _toDisplayString(submitting.value ? 'Saving…' : (__props.submitLabel ?? 'Save')), 9, _hoisted_32),
      _createVNode(_component_NuxtLink, {
        to: "/admin/talks",
        class: "text-muted hover:text-primary self-center text-sm"
      }, {
        default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
          _createTextVNode(" Cancel ", -1)
        ]))]),
        _: 1
      })
    ])
  ], 32))
}
}

})